import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';

import { apiErrorMessages } from './Error.messages';
import { ERROR_CODE_MESSAGES } from './ApiError.constants';

export const isBillingError = error => error && error.code >= 4301 && error.code <= 4320;
export const errorCodeHasMessage = errorCode => Object.keys(ERROR_CODE_MESSAGES).includes(String(errorCode));

// NOTE: this is a hack so that sagas can universally represent the generic error message
export const GENERIC_ERROR = Object.freeze({ isGenericError: true });

export class ApiError extends Component {
  static billingErrorReducer(memo, error) {
    if (error && (error.code === 4608 || isBillingError(error))) {
      return error;
    }

    return memo;
  }

  static extractMessage(error) {
    if (error) {
      if (typeof error === 'string') {
        return error;
      }

      if (error.code && errorCodeHasMessage(error.code)) {
        return ERROR_CODE_MESSAGES[error.code];
      }

      if (error.message) {
        return error.message;
      }

      if (error.details) {
        return error.details;
      }
    }

    return apiErrorMessages.genericMessage;
  }

  static messageForDisplay(errors, reducer, codes = []) {
    const reducerToUse = reducer || ((memo, err) => (codes.indexOf(err.code) !== -1 ? err : memo));
    const error = (errors || []).reduce(reducerToUse, null);
    return ApiError.extractMessage(error);
  }

  errors() {
    const { errors, error } = this.props;

    return (errors || []).concat(error).filter(err => !!err);
  }

  surfacedErrorCodes() {
    const { surfacedErrorCodes, surfacedErrorCode } = this.props;

    return (surfacedErrorCodes || []).concat(surfacedErrorCode).filter(code => !!code);
  }

  render() {
    const { extraClasses, reduce } = this.props;

    const errors = this.errors();
    const codes = this.surfacedErrorCodes();

    if (!errors.length) {
      return false;
    }

    const message = ApiError.messageForDisplay(errors, reduce, codes);
    return (
      <div className={`error__text ${extraClasses || ''}`}>
        <LocalizableMessage message={message} />
      </div>
    );
  }
}

const errorShape = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]);

ApiError.propTypes = {
  error: errorShape,
  errors: PropTypes.arrayOf(errorShape),
  extraClasses: PropTypes.string,
  reduce: PropTypes.func,
  surfacedErrorCode: PropTypes.number,
  surfacedErrorCodes: PropTypes.arrayOf(PropTypes.number),
};
